'use client';

import { Button } from '@ui/components/button';
import { cn } from '@ui/lib/utils';
import { text } from '@modules/garden-planner/text';
import { useRef, useEffect } from 'react';
import { FaIcon } from '@micks-yard/icons/FaIcon';
import { faCircleCheck } from '@micks-yard/icons/solid/faCircleCheck';

interface AvailabilityToolViewProps {
  isActive: boolean;
  onToggle: () => void;
  onSetAllCellsAvailability: (available: boolean) => void;
}

export function AvailabilityToolView({
  isActive,
  onToggle,
  onSetAllCellsAvailability,
}: AvailabilityToolViewProps) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isActive && ref.current) {
      ref.current.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }, [isActive]);

  return (
    <div ref={ref}>
      <div className="mb-3">
        <Button
          type="button"
          variant={isActive ? 'ghost' : 'outline'}
          className={cn(
            'w-full justify-start gap-2',
            isActive && 'bg-green-100 text-green-800 hover:bg-green-200 hover:text-green-800'
          )}
          onClick={onToggle}>
          <FaIcon icon={faCircleCheck} className="size-4" />
          {isActive ? text.exitAvailability : text.editAvailability}
        </Button>

        {isActive ? (
          <div className="bg-muted mt-2 flex flex-col gap-2 rounded-r-md border-l-4 border-l-green-600 py-3 pr-3 pl-3">
            <p className="text-muted-foreground text-sm">{text.availabilityHint}</p>
            <div className="flex w-full flex-col gap-2">
              <Button
                type="button"
                className="w-full"
                size="sm"
                onClick={() => onSetAllCellsAvailability(true)}>
                {text.enableAll}
              </Button>
              <Button
                type="button"
                variant="destructive"
                className="w-full"
                size="sm"
                onClick={() => onSetAllCellsAvailability(false)}>
                {text.disableAll}
              </Button>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
}
